import React, { useRef, useState, useEffect } from 'react';

export default function EditModalButton({orderSnapshot}) {

  const noteSnapshot = orderSnapshot.child('deliveryInstructions');
  const originalNoteSnapshot = orderSnapshot.child('originalDeliveryInstructions');
  const dialogRef = useRef(null);
  const [text, setText] = useState(noteSnapshot.val());

//   useEffect(() => {
//         if (dialogRef.current) {
//             dialogRef.current.showModal();
//             }
//   }, [0])

  const openDialog = () => {
    if (!originalNoteSnapshot.exists() && noteSnapshot.val()) {
      console.log('backing up original note');
      originalNoteSnapshot.ref.set(noteSnapshot.val());
    }


    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  };

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };

  const backupOriginalText = () => {
    originalNoteSnapshot.set(text)
  }

  const handleSubmit = () => {
    console.log("Submitted text:", text);
    noteSnapshot.ref.set(text);
    closeDialog();
  };

  const numOfChars = text.length;
  return (
    <div>
      <button onClick={openDialog}>Edit Delivery Note</button>


      <dialog ref={dialogRef} style={styles.dialog}>
        <form method="dialog" onSubmit={e => e.preventDefault()}>
            {/* 280 max chars */}
          <h3>Modify Delivery Note</h3> 

          <p>**MUST SUBMIT before driver request for driver to see modified note.</p>

          <div style={styles.originalNote}>
            <h3>Original Note:</h3>
            <p>{originalNoteSnapshot.val() || 'N/A'}</p>
          </div>

             <div style={{ margin: '1em 0' }}>
            <button type="button" onClick={handleSubmit}>Submit</button>
            <button type="button" onClick={closeDialog} style={{ marginLeft: '0.5em' }}>Cancel</button>
          </div>
            <div style={{ marginBottom: '1em' }}>
                <span>Characters: {numOfChars} / 280</span>
            </div>

          <textarea
            rows="5"
            cols="40"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
         
        </form>
      </dialog>
    </div>
  );
}

const styles = {
  dialog: {
    width: '100%',
    maxWidth: '500px',
    border: 'none',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
  },
  textarea: {
    width: '100%',
    minHeight: '150px',
    resize: 'vertical',
    fontSize: '16px',
    padding: '10px',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  originalNote: {
    backgroundColor: '#f9f9f9',
    color: '#555',
    fontStyle: 'italic',
    padding: '10px',
    borderRadius: '4px',
    marginBottom: '1em',
  }
};